<template>
  <div class="list-group-item clearfix a">
    <div class="row">
      <div class="col-11">
        <a :href=link> {{title}}</a>
        <pre> Source : {{source}}    Published On: {{pubDate.slice(0,17)}}</pre>
      </div>
      <div class="col-1">
        <span class="pull-right">
      <button class="btn btn-xs" v-on:click="$emit('checked',result)">
        <i class="fa fa-angle-double-right"></i>
      </button>
    </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'resultItem',
  props: {
    title: String,
    link: String,
    pubDate: String,
    source: String,
    result: Object
  }
}
</script>

<style scoped>

</style>
